import { render } from "./RemoveFunds.vue?vue&type=template&id=1bb59966"
import script from "./RemoveFunds.vue?vue&type=script&lang=js"
export * from "./RemoveFunds.vue?vue&type=script&lang=js"

import "./RemoveFunds.vue?vue&type=style&index=0&id=1bb59966&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__